// No direct PHP counterpart.
// JS registry shim for api/fuel/app/classes/insights/player/*.php segments.

var requireSegment = require.context('.', false, /\.js$/)
var segments = []

requireSegment.keys().forEach(function(key) {
	if (key === './index.js') return
	var mod = requireSegment(key)
	var segment = mod.default || mod
	if (segment && typeof segment.valid === 'function') segments.push(segment)
})

export default {
	name: 'player',
	segments: segments
}
